import { isExpired } from '../utils/is-expired.js';
export class ExchangeLimits {
    #exchangeProviders;
    #cachedLimits = new Map();
    constructor(params) {
        this.#exchangeProviders = params.exchangeProviders;
    }
    getLimits = async ({ pairId, expiryMarginMs }) => {
        try {
            const limits = await this.#exchangeProviders.getExchangeLimits({ pairId, expiryMarginMs });
            this.#cachedLimits.set(pairId, limits);
            return limits;
        }
        catch (error) {
            const cached = this.#cachedLimits.get(pairId);
            if (cached?.expiry && !isExpired(cached.expiry, expiryMarginMs ?? 0))
                return cached;
            throw error;
        }
    };
}
const exchangeLimitsModuleFactory = (args) => new ExchangeLimits({ ...args });
const exchangeLimitsModuleDefinition = {
    id: 'exchangeLimits',
    type: 'module',
    factory: exchangeLimitsModuleFactory,
    dependencies: ['exchangeProviders'],
};
export default exchangeLimitsModuleDefinition;
